import {Pipe, PipeTransform} from '@angular/core';
import {LinesDto} from '../../../Models/Purchases/Shared/line.interface';

@Pipe({
  name: 'unpairedLines',
  standalone: false,
})
export class UnpairedLinesPipe implements PipeTransform {

  transform(lines: LinesDto[]): number {

    if (!lines?.length) {
      return 0;
    }

    return lines.filter((line) => !line.paired_scan_item?.id).length;

  }

}
